"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorageLimitBytes = exports.STORAGE_PACK_LOOKUP_KEY = exports.STORAGE_PACK_PRICE_CENTS = exports.STORAGE_PACK_BYTES = void 0;
/** One storage pack: 100 GiB for $29 a month, added to the account's subscription (decided 2026-10-02) */
exports.STORAGE_PACK_BYTES = 100 * 1024 ** 3;
exports.STORAGE_PACK_PRICE_CENTS = 2900;
/** Finds the pack's Stripe Price in any Stripe account (created on first use) */
exports.STORAGE_PACK_LOOKUP_KEY = "talon_storage_pack_100gib";
/**
 * An account's storage limit: its pricing tier's allowance plus its storage packs. A tier with no
 * allowance has no limit.
 */
const getStorageLimitBytes = (tierAllowanceBytes, storagePacks = 0) => tierAllowanceBytes
    ? Number(tierAllowanceBytes) + storagePacks * exports.STORAGE_PACK_BYTES
    : null;
exports.getStorageLimitBytes = getStorageLimitBytes;
//# sourceMappingURL=storage-limit.js.map